var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Go to Home page")]),_vm._v(" "),_c('h1',[_vm._v("About page")]),_vm._v(" "),_c('users-list',{attrs:{"users":_vm.users}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }